import { WidgetApi } from "../orchestrator/WidgetApi";
export class WidgetSettingsApi extends WidgetApi {
    constructor(widgetInstance) {
        super(widgetInstance);
        this._eventListeners = new Array();
        this._eventListenersInternal = new Array();
    }
    isConfigurationSupported() {
        return this._eventListeners.length > 0;
    }
    showSettings() {
        this.fireEventInternal("onShowSettings");
    }
    hideSettings() {
        this.fireEventInternal("onHideSettings");
    }
    addEventListener(listener) {
        this._eventListeners.push(listener);
        this.fireEventInternal("listenerChanged");
    }
    removeEventListener(listener) {
        let index = this._eventListeners.indexOf(listener);
        if (index > -1) {
            this._eventListeners.splice(index, 1);
            this.fireEventInternal("listenerChanged");
        }
    }
    onShowSettingsStart() {
        this.fireEvent("onShowSettingsStart");
    }
    onShowSettingsEnd() {
        this.fireEvent("onShowSettingsEnd");
    }
    onHideSettingsStart() {
        this.fireEvent("onHideSettingsStart");
    }
    onHideSettingsEnd() {
        this.fireEvent("onHideSettingsEnd");
    }
    /* eslint-disable sort-keys */
    addEventListenerInternal(listener) {
        this._eventListenersInternal.push({ listener });
    }
    removeEventListenerInternal(listener) {
        let index = this._eventListenersInternal.indexOf({ listener });
        if (index > -1) {
            this._eventListenersInternal.splice(index, 1);
        }
    }
    fireEvent(name) {
        for (let index = 0; index < this._eventListeners.length; index++) {
            if (this._eventListeners[index]) {
                this._eventListeners[index](name);
            }
        }
    }
    fireEventInternal(name) {
        for (let index = 0; index < this._eventListenersInternal.length; index++) {
            if (this._eventListenersInternal[index]) {
                // Runtime interface type checking isn't supported so we must check for the existence of the callback function member
                if ("widgetSettingsEventsCallback" in this._eventListenersInternal[index].listener) {
                    this._eventListenersInternal[index].listener.widgetSettingsEventsCallback(name);
                }
                else {
                    this._eventListenersInternal[index].listener(name);
                }
            }
        }
    }
}
